import { nullishToOptional } from "../helpers";
import { z } from "zod";
export const Customer = z.object({
    id: z.string(),
});
export const Address = z.object({
    street1: nullishToOptional(z.string()),
    street2: nullishToOptional(z.string()),
    city: nullishToOptional(z.string()),
    postal: nullishToOptional(z.string()),
    country: nullishToOptional(z.string()),
    state: nullishToOptional(z.string()),
});
export const BillingDetails = z.object({
    address: nullishToOptional(Address),
    email: nullishToOptional(z.string()),
    companyName: nullishToOptional(z.string()),
    companyId: nullishToOptional(z.string()),
    notes: nullishToOptional(z.string()),
    vat: nullishToOptional(z.string()),
    poNumber: nullishToOptional(z.string()),
});
